import { ROUTES, buildRoute } from "../routes/RouteNames";
import makeSlug from "./makeSlug";

// Odkaz na veřejný profil uživatele (slug je volitelný, ale držíme ho kvůli breadcrumbs)
export const buildUserProfilePath = (user) => {
    if (!user?.id) return buildRoute(ROUTES.HOME);

    const fullName = `${user.first_name || ""}-${user.last_name || ""}`.replace(/-+$/, "");
    const slug = makeSlug(fullName).replace(/_/g, "-");

    return slug
        ? buildRoute(ROUTES.USER_DETAIL, { id: user.id, slug })
        : buildRoute(ROUTES.USER_DETAIL, { id: user.id });
};

export default buildUserProfilePath;
